(function () {
  'use strict';

  var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function query(scope, selector) {
    return (scope || document).querySelector(selector);
  }

  function queryAll(scope, selector) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function setHidden(element, hidden) {
    if (!element) return;
    element.hidden = hidden;
  }

  function traplessCloseNavigation(header) {
    var nav = query(header, '[data-mobile-nav]');
    var toggle = query(header, '[data-menu-toggle]');
    var overlay = query(header, '[data-nav-overlay]');
    if (!nav) return;
    nav.classList.remove('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    setHidden(overlay, true);
    document.body.classList.remove('is-locked');
  }

  function initHeader(scope) {
    queryAll(scope, '[data-header]').forEach(function (header) {
      if (header.dataset.ready === 'true') return;
      header.dataset.ready = 'true';
      var menuToggle = query(header, '[data-menu-toggle]');
      var menuClose = query(header, '[data-menu-close]');
      var nav = query(header, '[data-mobile-nav]');
      var overlay = query(header, '[data-nav-overlay]');
      var searchToggle = query(header, '[data-search-toggle]');
      var searchDrawer = query(header, '[data-search-drawer]');

      if (menuToggle && nav) {
        menuToggle.addEventListener('click', function () {
          nav.classList.add('is-open');
          menuToggle.setAttribute('aria-expanded', 'true');
          setHidden(overlay, false);
          document.body.classList.add('is-locked');
          var firstLink = query(nav, 'a');
          if (firstLink) firstLink.focus();
        });
      }
      if (menuClose) menuClose.addEventListener('click', function () { traplessCloseNavigation(header); });
      if (overlay) overlay.addEventListener('click', function () { traplessCloseNavigation(header); });

      if (searchToggle && searchDrawer) {
        searchToggle.addEventListener('click', function () {
          var willOpen = searchDrawer.hidden;
          setHidden(searchDrawer, !willOpen);
          searchToggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
          if (willOpen) {
            var input = query(searchDrawer, 'input[type="search"]');
            if (input) input.focus();
          }
        });
      }

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          traplessCloseNavigation(header);
          if (searchDrawer && !searchDrawer.hidden) {
            setHidden(searchDrawer, true);
            if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
          }
        }
      });
    });
  }

  function formatMoney(cents, format) {
    var value = typeof cents === 'string' ? cents.replace('.', '') : cents;
    var template = format || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiter(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      var parts = (number / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
    }

    var match = template.match(placeholder);
    if (!match) return withDelimiter(value, 2);
    var output;
    switch (match[1]) {
      case 'amount_no_decimals': output = withDelimiter(value, 0); break;
      case 'amount_with_comma_separator': output = withDelimiter(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': output = withDelimiter(value, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': output = withDelimiter(value, 2, "'", '.'); break;
      default: output = withDelimiter(value, 2);
    }
    return template.replace(placeholder, output);
  }

  function refreshCartCount() {
    return fetch(rootPath + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to refresh cart.');
        return response.json();
      })
      .then(function (cart) {
        queryAll(document, '[data-cart-count]').forEach(function (badge) {
          badge.textContent = cart.item_count;
        });
        return cart;
      });
  }

  function submitProductForm(form) {
    var status = query(form, '.chs-form-status');
    var button = query(form, '[type="submit"]');
    var formData = new FormData(form);
    if (status) {
      status.hidden = false;
      status.classList.remove('is-error');
      status.textContent = form.dataset.addingLabel || 'Adding…';
    }
    if (button) button.disabled = true;

    return fetch(rootPath + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw new Error(data.description || data.message || form.dataset.errorLabel || 'Unable to add this item.');
          return data;
        });
      })
      .then(function (item) {
        document.dispatchEvent(new CustomEvent('cart:add', {
          detail: {
            id: item.variant_id || item.id,
            qty: Number(formData.get('quantity') || 1),
            item: item
          }
        }));
        if (status) status.textContent = form.dataset.addedLabel || 'Added to your cart.';
        return refreshCartCount();
      })
      .catch(function (error) {
        if (status) {
          status.classList.add('is-error');
          status.textContent = error.message;
        }
      })
      .finally(function () {
        var variantInput = query(form, '[data-variant-id]');
        if (button && (!variantInput || variantInput.value)) button.disabled = false;
      });
  }

  function initAjaxForms(scope) {
    queryAll(scope, '[data-ajax-product-form]').forEach(function (form) {
      if (form.dataset.ajaxReady === 'true') return;
      form.dataset.ajaxReady = 'true';
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        submitProductForm(form);
      });
    });
  }

  function variantInventoryText(variant, threshold, labels) {
    if (!variant.available) return labels.outOfStock;
    if (variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= threshold) {
      return labels.lowStock.replace('__COUNT__', variant.inventory_quantity);
    }
    return labels.inStock;
  }

  function initProduct(scope) {
    queryAll(scope, '[data-product-root]').forEach(function (productRoot) {
      if (productRoot.dataset.productReady === 'true') return;
      productRoot.dataset.productReady = 'true';
      var form = query(productRoot, '.chs-product-form');
      var variantScript = query(productRoot, '[data-variant-json]');
      if (!form || !variantScript) return;

      var variants;
      try { variants = JSON.parse(variantScript.textContent); } catch (error) { return; }
      var optionSelects = queryAll(form, '[data-option-position]');
      var variantInput = query(form, '[data-variant-id]');
      var addButton = query(form, '[data-add-to-cart]');
      var addLabel = query(form, '[data-add-label]');
      var price = query(productRoot, '[data-price]');
      var skuWrap = query(productRoot, '[data-sku-wrap]');
      var sku = query(productRoot, '[data-sku]');
      var inventory = query(productRoot, '[data-inventory]');
      var stickyButton = query(productRoot, '[data-sticky-submit]');
      var stickyLabel = query(productRoot, '[data-sticky-label]');
      var stickyPrice = query(productRoot, '[data-sticky-price]');
      var moneyFormat = productRoot.dataset.moneyFormat;
      var threshold = Number(productRoot.dataset.lowStock || 5);
      var labels = {
        inStock: productRoot.dataset.labelInStock,
        outOfStock: productRoot.dataset.labelOutOfStock,
        lowStock: productRoot.dataset.labelLowStock,
        add: productRoot.dataset.labelAdd,
        soldOut: productRoot.dataset.labelSoldOut,
        unavailable: productRoot.dataset.labelUnavailable
      };

      function chooseVariant() {
        var selectedOptions = optionSelects.map(function (select) { return select.value; });
        var variant = variants.find(function (candidate) {
          return candidate.options.every(function (value, index) { return value === selectedOptions[index]; });
        });
        if (!variant && variants.length === 1) variant = variants[0];

        if (!variant) {
          variantInput.value = '';
          addButton.disabled = true;
          if (addLabel) addLabel.textContent = labels.unavailable;
          if (stickyButton) stickyButton.disabled = true;
          if (stickyLabel) stickyLabel.textContent = labels.unavailable;
          return;
        }

        variantInput.value = variant.id;
        addButton.disabled = !variant.available;
        if (addLabel) addLabel.textContent = variant.available ? labels.add : labels.soldOut;
        if (stickyButton) stickyButton.disabled = !variant.available;
        if (stickyLabel) stickyLabel.textContent = variant.available ? labels.add : labels.soldOut;
        if (stickyPrice) stickyPrice.innerHTML = formatMoney(variant.price, moneyFormat);
        if (price) {
          var priceHtml = '';
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            priceHtml += '<s>' + formatMoney(variant.compare_at_price, moneyFormat) + '</s> ';
          }
          priceHtml += '<span>' + formatMoney(variant.price, moneyFormat) + '</span>';
          price.innerHTML = priceHtml;
        }
        if (skuWrap && sku) {
          sku.textContent = variant.sku || '';
          skuWrap.hidden = !variant.sku;
        }
        if (inventory) inventory.textContent = variantInventoryText(variant, threshold, labels);
        if (variant.featured_media_id) {
          var media = query(productRoot, '[data-media-id="' + variant.featured_media_id + '"]');
          if (media) {
            media.classList.add('is-active');
            media.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
          }
        }
        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      optionSelects.forEach(function (select) { select.addEventListener('change', chooseVariant); });
      queryAll(productRoot, '[data-media-target]').forEach(function (button) {
        button.addEventListener('click', function () {
          var media = query(productRoot, '[data-media-id="' + button.dataset.mediaTarget + '"]');
          queryAll(productRoot, '[data-media-target]').forEach(function (candidate) {
            candidate.removeAttribute('aria-current');
          });
          button.setAttribute('aria-current', 'true');
          if (media) {
            media.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest' });
            var video = query(media, 'video');
            if (video && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
              video.play().catch(function () {});
            }
          }
        });
      });
      if (stickyButton) stickyButton.addEventListener('click', function () { addButton.click(); });
      chooseVariant();
    });
  }

  function initFilters(scope) {
    queryAll(scope, '[data-collection-grid]').forEach(function (grid) {
      var toggle = query(grid, '[data-filter-toggle]');
      var filters = query(grid, '[data-filters]');
      var sort = query(grid, '[data-sort-select]');
      if (toggle && filters) {
        if (window.matchMedia('(max-width: 749px)').matches) {
          filters.hidden = true;
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          toggle.setAttribute('aria-expanded', 'true');
        }
        toggle.addEventListener('click', function () {
          filters.hidden = !filters.hidden;
          toggle.setAttribute('aria-expanded', filters.hidden ? 'false' : 'true');
        });
      }
      if (sort) sort.addEventListener('change', function () { sort.form.submit(); });
    });
  }

  function initRecommendations(scope) {
    queryAll(scope, 'product-recommendations[data-url]').forEach(function (element) {
      if (element.dataset.loaded === 'true' || element.innerHTML.trim()) return;
      element.dataset.loaded = 'true';
      fetch(element.dataset.url)
        .then(function (response) { return response.text(); })
        .then(function (text) {
          var html = new DOMParser().parseFromString(text, 'text/html');
          var incoming = query(html, 'product-recommendations');
          if (incoming && incoming.innerHTML.trim()) {
            element.innerHTML = incoming.innerHTML;
            initAjaxForms(element);
          }
        })
        .catch(function () {});
    });
  }

  function enforceMotionPreference(scope) {
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches || document.body.classList.contains('chs-motion-disabled');
    if (reducedMotion) {
      queryAll(scope, 'video[autoplay]').forEach(function (video) {
        video.pause();
        video.removeAttribute('autoplay');
      });
    }
  }

  function initReveals(scope) {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var elements = queryAll(scope, '.chs-main .shopify-section > section:not(.chs-hero)');
    if (!elements.length) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    elements.forEach(function (element) {
      if (element.classList.contains('chs-reveal-ready')) return;
      element.classList.add('chs-reveal-ready');
      observer.observe(element);
    });
  }

  function init(scope) {
    initHeader(scope);
    initAjaxForms(scope);
    initProduct(scope);
    initFilters(scope);
    initRecommendations(scope);
    enforceMotionPreference(scope);
    initReveals(scope);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
